import React from 'react'

import SVGIcon from '../../svg-icon/svg-icon'
import ContextMenuItem from '../context-menu-item/context-menu-item'

import TrashCanIcon from 'assets/images/icons/trashcan.svg'
import lang from '@/lang'

const ContextMenuDeleteItem = (props) => {
  const { label, onItemClick, tooltipText } = props

  const icon = <SVGIcon width="13px" height="13px" svg={ TrashCanIcon } fill='#757b8a' />

  return (
    <ContextMenuItem
      label={label}
      icon={icon}
      onItemClick={onItemClick}
      tooltipText={tooltipText} />
  )
}

ContextMenuDeleteItem.defaultProps = {
  label: lang.deleteButtonLabel,
}

export default ContextMenuDeleteItem
